import { registerPopoutComponent } from "../common/components/Popout"

export const doPopoutRegistration = () => {
    registerPopoutComponent('cad', async () => ({ default: (await import('./CAD')).CADPopout }));
}